/**
 * Formats a number as a percentage with appropriate precision.
 * @function formatPercentage
 * @param {number} value - The number to format as a percentage.
 * @returns {string} The formatted percentage string.
 */
export const formatPercentage = (value: number): string => {
  const fractionalPart = value.toString().split('.')[1] || '';
  const precision = Math.max(0, fractionalPart.length - 2);

  return (value * 100).toFixed(precision);
};
